<h1 mat-dialog-title>Cell Errors<mat-icon class="mat-icon-content-copy" (click)="copyToClipBoard()">content_copy</mat-icon></h1>
<div mat-dialog-content>
  <p *ngFor="let error of data.content;let i=index">* {{error}}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
</div>
